import { Text, Box, HStack, Image, Avatar } from '@chakra-ui/react';

export interface CompanyBadgeProps {
  companyName: string;
  companyLogo?: string;
}

const CompanyBadge: React.FC<CompanyBadgeProps> = ({ companyName, companyLogo }) => (
  <HStack spacing={3} align="center" wrap="wrap">
    <Box
      px={4}
      py={2}
      bg="white"
      borderRadius="xl"
      boxShadow="0 4px 12px rgba(0, 0, 0, 0.1)"
      border="1px solid"
      borderColor="blue.100"
      sx={{
        transform: 'translateY(-1px)',
        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
      }}
      display="flex"
      alignItems="center"
      gap={2}
    >
      {companyLogo ? (
        <Image
          src={companyLogo}
          alt={companyName + ' Logo'}
          boxSize="32px"
          borderRadius="full"
          objectFit="contain"
          mr={2}
          fallback={<Avatar size="sm" name={companyName} />}
        />
      ) : (
        <Avatar size="sm" name={companyName} mr={2} />
      )}
      <Text 
        fontWeight="bold" 
        color="blue.600"
        fontSize="lg"
        lineHeight="1"
      >
        {companyName}
      </Text>
    </Box>
  </HStack>
);

export default CompanyBadge;